import React from "react";

const ProfileDesktop = React.lazy(() => import("./ui/Profile"));

export const ProfilePage = () => {
  return <ProfileDesktop />;
};
